import { IStocksFilterList } from "../types/stocks-filter-types.types";
import { IStockAPIPaylod, IStockListCard } from "../types/stock-list-types.types";
import { API_PATHS } from "../constants/api-paths";
import { request } from "../core/api.client";

export const getStockList = async (payload: IStockAPIPaylod) => {
  const response: IStockListCard = await request({
    method: "POST",
    url: `${API_PATHS.stockList}`,
    data: payload,
  });
  return response;
};
export const getStocksFilterList = async () => {
  const response: IStocksFilterList = await request({
    method: "GET",
    url: `${API_PATHS.stocksFilterList}`,
  });
  return response;
};
